import React from "react";
import { Calculator } from "@/components/calculator/Calculator";
import { LanguageSwitcher } from "@/components/locale/LanguageSwitcher";

export const CalcPage = () => {
    return (
        <div style={{ position: "relative", minHeight: "100vh" }}>
            <div className="calc-language">
                <LanguageSwitcher />
            </div>
            <Calculator />
        </div>
    );
};
